//lib
import { Icon as Iconify } from "@iconify/react";

export default function Icon(props) {
  const { tag, icon, onClick, className, style, width, height } = props;

  const Tag = tag || "article";

  return (
    <Tag style={style} className="icon" onClick={onClick ? onClick : undefined}>
      <Iconify
        icon={icon}
        width={width}
        height={height}
        className={className ? className : ""}
      />
    </Tag>
  );
}
